import React, { useState } from "react";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { CaseServices } from "../../../services/CaseServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";

const DownloadTemplateButton = ({ payer }) => {
  const [downloading, setDownloading] = useState(false);

  const handleDownloadTemplate = async () => {
    if (!payer) {
      toast.error("Payer not found for this case");
      return;
    }

    setDownloading(true);
    try {
      const res = await CaseServices.getTpaTemplate(payer);
      const templateUrl = res?.data?.list?.[0]?.templateUrl;
      if (templateUrl) {
        window.open(templateUrl, "_blank", "noopener,noreferrer");
      } else {
        toast.error("No template found for this TPA");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div
      className={`self-center flex items-center gap-2 text-sm text-white font-semibold bg-[#017C57] px-4 py-2 rounded-full whitespace-nowrap ${
        downloading ? "opacity-60 cursor-wait" : "cursor-pointer"
      }`}
      onClick={downloading ? undefined : handleDownloadTemplate}
    >
      {downloading ? (
        <CircularProgress size={16} sx={{ color: "#FFFFFF" }} />
      ) : (
        <FileDownloadOutlinedIcon sx={{ fontSize: 18 }} />
      )}
      {downloading ? "Downloading..." : "Download Template"}
    </div>
  );
};

export default DownloadTemplateButton;
